<template>
  <b-col class="custom-grid" v-click-outside="() => (show = false)">
    <b-form-group>
      <label class="flex">Truck Id <span class="red">*</span></label>
      <div
        :class="selectOptions ? 'custom-total-icon customTotal' : 'customTotal'"
        @click="() => (show = !show)"
      >
        {{ selected }}

        <!-- list item -->
        <div class="select" v-if="listItems.length > 0 && show">
          <ul>
            <li
              v-for="(item, index) in listItems"
              values="1"
              :key="index"
              class="option"
              @click="
                () => {
                  show = false;
                  copyBoard(item[name]);
                }
              "
            >
              {{ item[name] }}
            </li>
          </ul>
        </div>
      </div>
    </b-form-group>
  </b-col>
</template>
<script>
import ClickOutside from "vue-click-outside";

export default {
  directives: {
    ClickOutside,
  },
  props: {
    value: { type: Array },
    name: { type: String, default: "truckId" },
    selectOptions: { type: Boolean, default: false },
  },
  data() {
    return {
      show: false,
      selected: "",
    };
  },
  mounted() {
    this.selected = this.value?.[0]?.[this.name];
  },
  methods: {
    copyBoard(value) {
      const clipboardData =
        event.clipboardData ||
        window.clipboardData ||
        event.originalEvent?.clipboardData ||
        navigator.clipboard;
      this.selected = value;
      clipboardData.writeText(value);
    },
  },
  computed: {
    listItems() {
      return this.value;
    },
  },
};
</script>
<style lang="scss">
.custom-total-icon:before {
  content: "";
  position: absolute;
  top: 16px;
  bottom: 0;
  right: 15px;
  width: 14px;
  background-size: 100%;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAAAmElEQVQokZ3SwQ3CIBTG8X+7gI6BNzawq3jnoOyBMcEBOooj1BNXV3ACzDOSGEuL8CWEvPeR34lOebcFRkDulD31uQNDF2Nkdz1r4AZsGiDJE9DB2EcvUzB2Ev1TtGCDYDL0aduIJmxKi/67rURn2AysRI+/WBb8Ez0EY8dckQUL6CK2Ci6gpzXsHfmHpaO808q7S/FtjLwAmwh101zduSgAAAAASUVORK5CYII=) !important;
  background-repeat: no-repeat;
}
.customTotal {
  width: 100%;
  background-color: #f2f2f2;
  display: flex;
  align-items: center;
  padding-left: 10px;
  height: 38px;
  border-radius: 5px;
  color: #000000;
  position: relative;

  .select {
    position: absolute;
    right: 14px;
    left: 0;
    right: 0;
    width: 100%;
    top: 50px;
    background-color: #f2f2f2;
    z-index: 99;
    ul {
      padding: 0 !important;
      margin: 0 !important;
    }

    li {
      cursor: copy;
      padding: 10px;
      border-bottom: 1px solid #ffffff;
      text-decoration: none;
      list-style: none;
    }
  }
}
</style>
